import {
  Component,
  OnInit
} from '@angular/core';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';


export class SkyListViewGridDemoComponent implements OnInit {
  public items = Observable.of([
    { id: '1', column1: 101, column2: 'Apple', column3: 'Anne eats apples' },
    { id: '2', column1: 202, column2: 'Banana', column3: 'Ben eats bananas' },
    { id: '3', column1: 303, column2: 'Pear', column3: 'Patty eats pears' },
    { id: '4', column1: 404, column2: 'Grape', column3: 'George eats grapes' },
    { id: '5', column1: 505, column2: 'Banana', column3: 'Becky eats bananas' },
    { id: '6', column1: 606, column2: 'Lemon', column3: 'Larry eats lemons' },
    { id: '7', column1: 707, column2: 'Strawberry', column3: 'Sally eats strawberries' }
  ]);

  public asyncHeading = new BehaviorSubject<string>('');

  public ngOnInit() {
    // Simulate async request:
    setTimeout(() => {
      this.asyncHeading.next('Column1');
    }, 1000);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-list-view-grid-demo',
  template: `<sky-list [data]="items" [defaultView]="grid">
  <sky-list-toolbar>
    <sky-list-secondary-actions>
      <sky-list-column-selector-action [gridView]="grid">
      </sky-list-column-selector-action>
    </sky-list-secondary-actions>
  </sky-list-toolbar>

  <sky-list-view-grid fit="scroll" #grid>
    <sky-grid-column
      field="control"
      [locked]="true"
      [template]="customCellTemplate">
    </sky-grid-column>
    <sky-grid-column
      field="column1"
      [locked]="true"
      [heading]="asyncHeading | async"
      description="A numbered column">
    </sky-grid-column>
    <sky-grid-column
      field="column2"
      heading="Column2"
      description="A fruit column">
    </sky-grid-column>
    <sky-grid-column
      field="column3"
      heading="Column3"
      description="A sentence column">
    </sky-grid-column>
  </sky-list-view-grid>
</sky-list>

<ng-template
  #customCellTemplate
  let-row="row">
  <sky-dropdown buttonType="context-menu">
    <sky-dropdown-menu>
      <sky-dropdown-item>
        <button type="button">
          Option 1
        </button>
      </sky-dropdown-item>
      <sky-dropdown-item>
        <button type="button">
          Option 2
        </button>
      </sky-dropdown-item>
      <sky-dropdown-item>
        <button type="button">
          Option 3
        </button>
      </sky-dropdown-item>
    </sky-dropdown-menu>
  </sky-dropdown>
</ng-template>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
